<template>
  <zm-alert
    v-if="visible"
    type="warning"
    show-icon
    :closable="false"
    class="opc-coupon__referral-warning"
  >
    <div>
      {{ $t('billing.coupon.referral_discount_conflict') }}
      <zm-button type="link" class="opc-coupon__referral-warning-undo" @click="handleUndo">
        {{ $t('billing.coupon.undo') }}
      </zm-button>
    </div>
  </zm-alert>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { couponFormModeMap } from '@/views/config/coupon/helper/constant';

export default {
  name: 'ReferralDiscountAlert',
  computed: {
    ...mapGetters(['isEligibleForReferAFriendDiscount']),
    visible() {
      return this.isEligibleForReferAFriendDiscount;
    },
  },
  methods: {
    ...mapMutations(['setCouponFormMode']),
    handleUndo() {
      this.setCouponFormMode(couponFormModeMap.INIT);
      this.$tracking.buyInteraction(
        'ui error',
        'alert error - your referral discount and coupon code cannot be combined - undo'
      );
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.$tracking.buyInteraction(
            'ui error',
            'alert error - your referral discount and coupon code cannot be combined - impression'
          );
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.opc-coupon__referral-warning {
  font-style: normal;
  line-height: 18px;
  margin-bottom: 24px;

  &-undo {
    &.zm-button--link {
      display: block;
      padding: 0;
      margin-top: 8px;
      font-size: inherit;
      line-height: inherit;
    }
  }
}
</style>
